import { StructureService } from "../../../services/structure.service";
import { filter, finalize, first, forkJoin, lastValueFrom, map, of, race, startWith, Subject, switchMap, take, takeUntil, tap, timer } from "rxjs";
import { AfterViewInit, ChangeDetectorRef, Component, OnDestroy, OnInit, QueryList, ViewChildren } from "@angular/core";
import { IColumns } from "./interfaces/icolumns";
import { NgbdSortableHeader } from "./directives/ngbd-sortable-header";
import { Settings } from "./interfaces/settings";
import { UrlService } from "../../../miscellaneous/url.service";
import { DataService } from "../../../services/data.service";
import { ActionHandlerService } from "src/app/services/action-handler.service";
import { EditAction } from "./actions/edit-action";
import { DownloadFileAction } from "./actions/download-file-action";
import { PreviewFileAction } from "./actions/preview-file-action";
import { CsvDataService } from "src/app/services/csv-data.service";
import { Router } from "@angular/router";
import { DatePipe } from "@angular/common";
import { IColumn } from "./interfaces/icolumn";
import { FormComponent } from "../forms/forms.component";
import { ICategory } from "src/app/models/category";
import { VocabularyService } from "src/app/services/vocabulary-service.service";
import { DeleteAction } from "./actions/delete-action";
import { DeleteAssociationAction } from "./actions/delete-association-action";
import { ConfirmationDialogService } from "src/app/services/confirmation-dialog.service";
import { DeleteAssociationVocabularyAction } from "./actions/delete-association-vocabulary";
import { UserPermissionService } from "src/app/services/permission.service";
import { TypesAction } from "./interfaces/actions";
import { environment } from "src/environments/environment";
import { MenuService } from "src/app/services/menu-service.service";
import { mapToButtonType } from "src/app/helpers/button-type.enum";
import { AuthService } from "src/app/services/auth.service";
import { ObbligoProvider } from "src/app/services/obbligo.provider";
import { SharedDataBridgeService } from "src/app/services/shared-data-bridge.service";
import { FormService } from "src/app/services/form.service";
import { DeleteFileAction } from "./actions/delete-file-action";


@Component({
  selector: "smart-table",
  templateUrl: "./smart-table.component.html",
  styleUrls: ["./smart-table.component.scss"],
  providers: [UrlService, DatePipe, FormComponent],
})
export class SmartTableComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChildren(NgbdSortableHeader)
  headers!: QueryList<NgbdSortableHeader>;

  static compName = "SmartTable";

  protected readonly onclick = onclick;

  private badgeClasses = {
    success: ["Si", "OK", "In corso"],
    danger: ["No", "KO", "Scaduta"]
  };

  private tableConfigured = false;
  private hasLoadedViaSharedEndpoint = false;

  data: any[] = [];
  settings!: Settings;
  name!: string;
  endpoint!: string;
  editPage!: string;
  props: any = {};
  valueEndpoint: string = "";
  concatIdObbligo?: boolean;
  concatFileIdObbligo?: boolean;
  columns!: IColumns;
  keys: any;
  collectionSize: number = 0;
  pageIndex: number = 0;
  pageSize: number = 0;
  maxSize: number = 0;
  dataTable: any[] = [];
  configPagination: any = {
    index: undefined,
    direction: "",
    column: undefined,
  };
  loading: boolean = false;
  loadingPermission: boolean = false;
  id: string | undefined | false;
  dynamicColumns: ICategory[] = [];
  destroy$ = new Subject<void>();
  model: any;
  permittedActions: TypesAction[] = [];

  constructor(
    private ssv: StructureService,
    private serviceUrl: UrlService,
    private dataService: DataService,
    private actionHandlerService: ActionHandlerService,
    private csvService: CsvDataService,
    private router: Router,
    private datePipe: DatePipe,
    private vocabularyService: VocabularyService,
    public confirmationDialogService: ConfirmationDialogService,
    private _permissionService: UserPermissionService,
    private cdRef: ChangeDetectorRef,
    private menuService: MenuService,
    private authService: AuthService,
    private _obbligoProvider: ObbligoProvider,
    private sharedDataBridge: SharedDataBridgeService,
    private formService: FormService,
    private ds: DataService
  ) { }



  /**
   * @inheritdoc
   */
  ngOnInit(): void {

    // this.settings.paginationRemote = {
    //   page: 0,
    //   size: 10,
    //   sortBy: "dataProvvedimento",
    //   sortDirection: 'DESC'
    // };
    // const token = await this.keycloakService.getToken(); // Ottieni il token JWT
    // console.log(token);

    this.valueEndpoint = this.settings?.valueEndpoint || "";
    this.concatIdObbligo = this.settings?.concatIdObbligo;
    this.concatFileIdObbligo = this.settings?.concatFileIdObbligo;
    this.setEndpoint();
    this.actionHandlerService.register("edit", new EditAction(this));
    this.actionHandlerService.register("delete", new DeleteAction(this));
    this.actionHandlerService.register("deleteFile", new DeleteFileAction(this));
    this.actionHandlerService.register("deleteAssociation", new DeleteAssociationAction(this));
    this.actionHandlerService.register("deleteAssociationVocabulary", new DeleteAssociationVocabularyAction(this));
    this.actionHandlerService.register("download", new DownloadFileAction(this));
    this.actionHandlerService.register("preview", new PreviewFileAction(this));
    this.settings.export = this.settings.export ?? true;

    if (this.settings.showActions) {
      this.checkPermission();
    }

    if (!this.router.url.startsWith(`/${environment.adminPath}`)) {
      this.subscribeToObbligoDetails((ob) => {
        if (ob && ob.id) {
          this.endpoint = this.appendIdObbligo(this.endpoint, ob);
          this.settings.vocabulariesEndpoint = this.appendIdObbligo(this.settings.vocabulariesEndpoint, ob);
        }
        this.getTable();
      });
    } else if (this.concatFileIdObbligo) {
      this.settings.vocabulariesEndpoint = this.settings.vocabulariesEndpoint + "/" + this.id;
    } else {
      this.getTable();
    }

    this.ds.modelData$.subscribe((model) => {
      if (this.settings.paginationRemote) this.settings.paginationRemote.page = 0;
      this.pageIndex = 0;
      this.model = model;
    });

  }

  subscribeToObbligoDetails(callback: (ob: any) => void): void {
    race(
      this._obbligoProvider.obbligoDetails$.pipe(
        filter((ob) => !!ob),
        take(1)
      ),
      timer(500).pipe(map(() => null))
    ).subscribe(callback);
  }


  getTable(): void {
    // Controllo se ci sono query params
    if (this.isDataBridgeEndpointSet()) return;
    // Funzione per ottenere i dati della tabella
    /*if (this.settings.pagination.hidden || this.data.length <= this.pageSize) {
      this.ssv.getDataTable(this.endpoint).subscribe((response) => {
        this.data = response;
        this.dataTable = this.data;
      });
    }*/
  }

  appendIdObbligo(endpoint: string, ob: any): string {
    if (!this.concatIdObbligo || !(ob.id as string))
      return endpoint;
    const idObbligo = ob.id as string;
    return endpoint.endsWith(idObbligo) ? endpoint : endpoint + "/" + idObbligo;
  }

  checkPermission(): void {
    if (environment.allowPermissions || this.settings.showActionsForce || !this.authService.isAdminUrl()) {
      this.permittedActions = this.settings.actions.map((act) => act.type);
      this.loadingPermission = false;
      return;
    }

    this.loadingPermission = true;

    race(
      this.menuService.menuItem$.pipe(filter((item) => !!item), take(1)),
      timer(2000).pipe(map(() => null))
    ).pipe(
      switchMap((item) => {
        const entityType = item?.entityType ?? undefined;

        return forkJoin(
          this.settings.actions.map((act) =>
            this._permissionService
              .loadCheckPermission(entityType, mapToButtonType(act.type.toString()))
              .pipe(
                tap((hasPermission: boolean) => {
                  if (hasPermission) {
                    this.permittedActions.push(act.type);
                  }
                })
              )
          )
        );
      }),
      finalize(() => (this.loadingPermission = false))
    ).subscribe();
  }



  /**
   * @inheritdoc
   */
  async ngAfterViewInit(): Promise<void> {

    const buildTable = async () => {
      this.sharedDataBridge.endpoint$.subscribe((endpoint) => {
        if (endpoint) {
          this.loadDataWithEndpoint(endpoint);
        }
      });

      this.ssv.isFilterEventEmitter.pipe(takeUntil(this.destroy$)).subscribe((filterModel) => {
        this.onFilterUpdate(filterModel);
      });

      this.buildTable();
      setTimeout(() => this.cdRef.detectChanges(), 100);
    }

    if (!this.router.url.startsWith(`/${environment.adminPath}`)) {
      this.subscribeToObbligoDetails(async () => {
        buildTable();
      });
    } else {
      buildTable();
    }

  }


  /**
   * Setta la tabella con i filtri da query params
   */
  loadDataWithEndpoint(endpoint: string): void {
    this.hasLoadedViaSharedEndpoint = true;
    this.loading = true;

    this.serviceUrl.getQueryParams().subscribe({
      next: (value) => {
        this.ssv.filterDataTable({ ...value }, endpoint, this.settings.paginationRemote)
          .pipe(
            take(1),
            tap((response) => {
              this.model = { ...value };
              if (this.settings.paginationRemote) this.settings.paginationRemote.page = 0;
              this.pageIndex = 0;
              this.configureTableOnce();
              this.setDatatable(response);
            }),
            finalize(() => this.loading = false)
          )
          .subscribe();
      },
    });
  }

  /**
   * Imposta l'endpoint per recuperare i dati della tabella.
   */
  setEndpoint(): void {
    // se l'url ha la pagina corrispondente a widget name ed è presente un valore id
    // allora accodo id nell'endpoint ex. edit/2 o allegati/obst/2
    let id = this.serviceUrl.getUrlId(this.settings.page);

    sessionStorage.removeItem('idObbligo');

    if (this.settings?.saveIdObbligo && id) {
      sessionStorage.setItem('idObbligo', id);
    }

    if (id) {
      this.id = id;
      if (this.endpoint) {
        this.endpoint = this.serviceUrl.appendId(this.endpoint, id);
      }
    }
  }

  /**
   * Richiama il VocabularyService che restituisce le colonne dinamiche.
   */
  async loadDynamicColumns(): Promise<void> {
    const response = await lastValueFrom(
      this.vocabularyService.vocabularies$.pipe(
        first(),
        switchMap((vocabularies: ICategory[]) => {
          if (this.settings.vocabulariesEndpoint) {
            return this.dataService.getData(this.settings.vocabulariesEndpoint).pipe(
              tap((newVocabularies) => this.vocabularyService.emit(newVocabularies))
            );
          } else {
            return of(vocabularies);
          }
        }),
        takeUntil(this.destroy$)
      )
    );

    const excludeColumnsId = this.settings.excludeColumnsId || [];
    const column = response.filter(
      (col: { id: { toString: () => string } }) => !excludeColumnsId.includes(col.id.toString())
    );

    this.dynamicColumns = column;
    this.addDynamicColumnToSettings();
  }

  /**
   * Aggiunge le colonne dinamiche alla configurazione della tabella.
   */
  addDynamicColumnToSettings(): void {
    if (!this.settings.columns) {
      this.settings.columns = {};
    }
    this.dynamicColumns?.forEach((col: ICategory) => {
      this.settings.columns[col.name] = {
        title: col.description,
        sortable: true,
      };
    });

    this.configureTableOnce();
  }

  /**
   * Se esiste valueEndpoint è dinamica, quindi
   * richiama il metodo per la gestione delle colonne dinamiche,
   * altrimenti chiama il servizio che restituisce i dati.
   */
  async buildTable(): Promise<void> {
    // Controllo se ci sono query params
    if (this.isDataBridgeEndpointSet()) return;
    if (this.endpoint.match("{")) return;

    if (this.valueEndpoint) {
      await this.loadDynamicColumns();

      this.loadConcatDataTable();
    } else {
      this.callServer();
    }
  }

  private callServer(): void {
    this.loading = true;
    this.ssv
      .getDataTable(this.endpoint, this.settings.paginationRemote)
      .pipe(
        take(1),
        tap((response) => {
          this.configureTableOnce();
          this.setDatatable(response);
        })
      ).pipe(finalize(() => (this.loading = false)))
      .subscribe();
  }

  /**
   * Chiama settingConfiguration se non è stato mai chiamato.
   */
  private configureTableOnce() {
    if (!this.tableConfigured) {
      this.settingConfiguration();
      this.tableConfigured = true;
    }
  }

  /**
   * Controlla sul sharedDataBridge se l'endpoint è stato aggiunto.
   */
  private isDataBridgeEndpointSet(): boolean {
    return this.sharedDataBridge.hasEndpoint();
  }

  /**
   * Carica i dati della tabella con colonne dinamiche.
   */
  loadConcatDataTable(filterModel?: { model: any; endpoint: string }): void {
    const endpoint = filterModel ? filterModel.endpoint : this.endpoint;;
    this.loading = true;
    this.ssv
      .concatDataTable(endpoint, this.valueEndpoint, this.dynamicColumns, filterModel?.model, this.settings?.callServerCategories ?? true, this.settings.paginationRemote)
      .pipe(
        take(1),
        tap((response) => {
          this.setDatatable(response);
        })
      ).pipe(finalize(() => (this.loading = false)))
      .subscribe();
  }

  /**
   * Imposta i dati della tabella dalla response.
   */
  setDatatable(r: any): void {

    let response = this.settings.paginationRemote && r.content ? r.content : r;

    if (response && this.settings.extractFrom) {
      response = response[this.settings.extractFrom];
    }

    this.data = response.content ? response.content : response;

    this.collectionSize = this.settings.paginationRemote && r.totalElements ? r.totalElements : this.data.length;

    if (this.settings.page === 'calcoli') {
      this.formService.setDataTable([]);
      this.formService.setLoadingState(false);

      this.formService.loading$.subscribe({
        next: (loading) => {
          this.loading = loading;
        }
      });

      this.formService.dataTable$.subscribe((data) => {
        this.dataTable = data
        if (data) {
          this.updateDataTable();
          return;
        }
      })

      return;
    }

    this.updateDataTable();
  }

  /**
   * Per la paginazione. Aggiorna i dati della tabella in base alla configurazione passata.
   */
  updateDataTable(config?: any): void {
    config = config || this.configPagination;

    const startIndex = (config.index - 1) * this.settings.pagination.pageSize;
    const endIndex = startIndex + this.settings.pagination.pageSize;
    this.dataTable = this.getDataOrdered(config.direction, config.column)?.slice(startIndex, endIndex);

  }

  isObjectValid(obj: any): boolean {
    return !!obj && Object.keys(obj).length > 0 && Object.values(obj).some(value => value !== null && value !== undefined);
  }

  updateDataTableRemote(config?: any): void {

    config = config || this.configPagination;
    if (this.settings.paginationRemote)
      this.settings.paginationRemote.page = config.index ? config.index - 1 : this.settings.paginationRemote?.page;

    if (this.isObjectValid(this.model)) {
      this.applyFilter(this.model, this.insertSearchInEndpoint());
    } else {
      this.callServer();
    }

  }


  /**
   * Si sottoscrive all'evento del click sul pulsante Filtra ed effettua la chiamata al servizio per filtrare i dati.
   */
  onFilterUpdate(filterModel: { model: any; endpoint: string }): void {
    if (this.valueEndpoint) {
      this.loadConcatDataTable(filterModel);
    } else {
      this.applyFilter(filterModel.model, filterModel.endpoint);
    }
  }

  /**
   * Imposta la configurazione della tabella.
   */
  settingConfiguration(): void {
    let integration: {} = {};

    this.settings = { ...this.settings, ...integration };
    this.columns = this.settings.columns;
    this.keys = Object.keys(this.columns);

    this.pageIndex = this.settings.pagination.pageInitial;
    this.pageSize = this.settings.paginationRemote?.size ? this.settings.paginationRemote?.size : this.settings.pagination.pageSize;
    this.maxSize = this.settings.pagination.maxSize;
    this.configPagination.index = this.pageIndex;

  }


  /**
   * Ordina i dati della tabella in base alla colonna selezionata.
   */
  onSort(sortEvent: any, col: string) {
    this.headers
      .filter((header) => header.sortable !== sortEvent.column || sortEvent.direction === "")
      .forEach((header) => (header.direction = ""));

    this.configPagination.direction = sortEvent.direction;
    this.configPagination.column = col;
    this.updateDataTable();
  }

  /**
   * Restituisce il titolo della colonna.
   */
  getTitle(col: string): string {
    return `${this.settings.columns[col].title}`;
  }

  /**
   *  Verifica se la colonna è ordinabile.
   */
  isSortable(col: string): boolean {
    return this.settings.columns[col].sortable || false;
  }

  /**
   * Al click sulla sort header.
   */
  getDataOrdered(direction?: string, column?: string) {
    if (!direction || direction === "" || !column) return this.data;

    return this.data?.sort((a, b) => {
      const res = this.compare(a[column], b[column]);
      return direction === "asc" ? res : -res;
    });
  }

  /**
   *  Confronta due valori per l'ordinamento.
   */
  compare(v1: string | number, v2: string | number): number {
    if (v1 && v2) {
      const comparison = (a: any, b: any) => (a < b ? 1 : -1);

      if (typeof v1 === "number" && typeof v2 === "number")
        // Casistica numerici
        return comparison(v1, v2);

      const val1 = v1 as string;
      const val2 = v2 as string;
      const formatoData = /^\d{2}-\d{2}-\d{4}$/;

      if (formatoData.test(val1) && formatoData.test(val2)) {
        // Casistica date a stringa
        const [giorno1, mese1, anno1] = val1.split("-");
        const [giorno2, mese2, anno2] = val2.split("-");
        const d1 = new Date(parseInt(anno1), parseInt(mese1) - 1, parseInt(giorno1));
        const d2 = new Date(parseInt(anno2), parseInt(mese2) - 1, parseInt(giorno2));

        return comparison(new Date(d1), new Date(d2));
      }
      return val2.localeCompare(val1); // Casistica stringhe
    }
    return 0;
  }

  /**
   * Esporta i dati della tabella in formato CSV.
   */
  exportData() {
    let dataCorrente = this.datePipe.transform(new Date(), "dd-MM-yyyy"); // Formatta la data corrente come giorno-mese-anno
    let nomeFile = this.router.url.replace("/", "") + "-" + dataCorrente + ".csv";

    const filterProperties = (obj: any, properties: string[]) => {
      let filteredObj: any = {};
      properties.forEach((prop) => {
        if (obj.hasOwnProperty(prop)) {
          filteredObj[prop] = obj[prop];
        }
      });
      return filteredObj;
    };

    if (this.data.length > 0) {
      const items = this.data.map((data) => {
        const csvLine = filterProperties(data, this.keys);
        return csvLine;
      });

      this.csvService.exportToCsv(nomeFile, items);
    }
  }

  /**
   * Restituisce la classe da applicare al badge in base al valore passato.
   */
  getBadgeClass(value: string, row?: any, col?: any): string {
    if (!value) {
      row[col] = row["labelResultEmpty"];
      return "bg-warning";
    }
    const compareValue = value.toLowerCase();
    if (this.badgeClasses.success.some((val) => val.toLowerCase() === compareValue)) {
      return "bg-success";
    } else if (this.badgeClasses.danger.some((val) => val.toLowerCase() === compareValue)) {
      return "bg-danger";
    } else {
      return "bg-warning";
    }
  }

  /**
   * Tronca il testo se supera la lunghezza massima. //TODO  Qui ci sarebbe da fare una pipe.
   */
  truncateText(text: string, maxLength?: number): string {
    if (maxLength === undefined || maxLength === null) {
      return text || "";
    }
    if (!text || text.length <= maxLength) {
      return text || "";
    }
    return text.substring(0, maxLength) + "...";
  }

  /**
   * Formatta il valore in base al tipo di colonna. //TODO Anche qui sarebbe meglio una pipe.
   */
  formatValue(col: string, val: any): string {
    const column: IColumn = this.columns[col];
    const value = val[col];

    if (!value) return "N/D";
    if (column.pipe === "date") {
      return this.datePipe.transform(value, "dd.MM.yyyy") || "";
    }
    if (typeof value === "boolean") {
      value ? (val[col] = "Si") : (val[col] = "No");
      return value ? "Si" : "No";
    }
    const limit = column.limitChar || (value ? value.length : 0);

    return value && value.length > limit ? value.substring(0, limit) + "..." : value;
  }

  /**
   * Esegue l'azione corrispondente al pulsante cliccato.
   */
  onClick(row: any, val: any): any {
    this.actionHandlerService.execute(row, val);
  }

  /**
   * Restituisce il servizio per la gestione delle url.
   */
  getServiceUrl(): UrlService {
    return this.serviceUrl;
  }

  /**
   * Restituisce il servizio dei dati.
   */
  getDataService(): DataService {
    return this.dataService;
  }

  /**
   * @inheritdoc
   */
  ngOnDestroy() {
    this.vocabularyService.clear();
    this.destroy$.next();
    this.destroy$.complete();
  }

  getEntries(map: Map<number, string> | any): { key: number, value: string }[] {
    if (map instanceof Map) {
      return Array.from(map.entries()).map(([key, value]) => ({ key, value }));
    } else if (typeof map === 'object' && map !== null) {
      return Object.entries(map).map(([key, value]) => ({ key: Number(key), value: String(value) }));
    }
    return [];
  }

  concatValue(col: string, val: any): string {
    return this.getEntries(val[col])
      .map(entry => entry.value)
      .join(', ');
  }

  getLinkHref(link: { value: string; prop: string; base_url?: string }, val: any): string {
    const base = link.base_url ? (environment as any)[link.base_url] + '/' : '';
    return `${base}${link.value}/${val[link.prop]}`;
  }

  private insertSearchInEndpoint = () => this.endpoint + "/search";

  private applyFilter(model: any, endpoint: string): void {

    this.ssv
      .filterDataTable(model, endpoint, this.settings.paginationRemote)
      .pipe(
        take(1),
        tap((response) => this.setDatatable(response)),
        finalize(() => (this.loading = false))
      )
      .subscribe();
  }

  getLink(col: any, val: any): string | null {
    return this.buildLink(col, val);
  }


  private buildLink(link: any, val: any): string | null {

    if (!link) return null;

    if (typeof link === 'string') {
      return link;
    }

    let base = link.value ?? '';

    if (link.prop && val?.[link.prop] !== undefined) {
      base += ('/' + val[link.prop]);
    }

    return base;
  }

}
